import {DEFAULT_REDIRECT} from '../config/config.js'
import {PERMS} from '../config/permissions'

// use import for system components
// for prevent recursive async chunk loading error if user have wrong cached files
// шаблоны
import MainLayout from '../common/layout/main-layout.vue'
import AuthLayout from '../common/layout/auth-layout.vue'
import AccountUserProfileLayout from '../app/account/UserProfileLayout.vue'

// main
import MainError from '../app/main/Error.vue'

// авторизация/регистрация
import AuthLogin from '../app/auth/Login.vue'
import AuthRegisterSetPassword from '../app/auth/RegisterSetPassword.vue'
import AuthRequestResetPassword from '../app/auth/RequestResetPassword.vue'

// личный кабинет пользователя
const AccountUserProfile = () => import(/* webpackChunkName: "sverd.account" */ '../app/account/UserProfile.vue')

// нормативы билинга
const NormativeApartmentBuildings = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/normative/ApartmentBuildings.vue')
const NormativeApartmentBuildingUpdate = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/normative/ApartmentBuildingUpdate.vue')
const NormativeIndividualAreas = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/normative/IndividualAreas.vue')
const NormativeIndividualAreaUpdate = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/normative/IndividualAreaUpdate.vue')
const NormativeLegalEntities = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/normative/LegalEntities.vue')
const NormativeLegalEntityUpdate = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/normative/LegalEntityUpdate.vue')

const BillingBranchs = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/billing/Branchs.vue')
const BillingBranchUpdate = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/billing/BranchUpdate.vue')
const BillingBanks = () => import(/* webpackChunkName: "kaluga.bank" */ '../app/billing/Banks.vue')
const BillingUpdate = () => import(/* webpackChunkName: "kaluga.bank" */ '../app/billing/BankUpdate.vue')

// платежные документы
const PaymentInvoices = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/payment/Invoices.vue')
const PaymentInvoiceCreate = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/payment/InvoiceCreate.vue')
const PaymentInvoicePacketErrors = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/payment/InvoicePacketErrors.vue')
const PaymentInvoicePacketItems = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/payment/InvoicePacketItems.vue')
const PaymentAccrualsLegals = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/payment/AccrualsLegals.vue')
const PaymentAccrualsLegalCreate = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/payment/AccrualsLegalCreate.vue')
const PaymentAccrualsLegalPacket = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/payment/AccrualsLegalPacket.vue')

// контроль счетов
const InvoiceControlBankStatements = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/invoice-control/BankStatements.vue')
const InvoiceControlBankStatementCreate = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/invoice-control/BankStatementCreate.vue')
const InvoiceControlBankStatementItems = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/invoice-control/BankStatementItems.vue')
const InvoiceControlBankStatementItemsLinkCreate = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/invoice-control/BankStatementItemsLinkCreate.vue')
const InvoiceControlBillsOfWasteGenerators = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/invoice-control/BillsOfWasteGenerators.vue')
const InvoiceControlBillOfWasteGeneratorUpdate = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/invoice-control/BillOfWasteGeneratorUpdate')

// платежи
const PaymentPayments = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/payment/Payments.vue')
const PaymentPaymentUpdate = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/payment/PaymentUpdate.vue')
// платеж по счетам
const PaymentPaymentBills = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/payment/PaymentBills.vue')
const PaymentPaymentBillUpdate = () => import(/* webpackChunkName: "kaluga.billing" */ '../app/payment/PaymentBillUpdate.vue')


// банковские пачки
const BankPacketsUploadedPackets = () => import(/* webpackChunkName: "kaluga.BankPackets" */ '../app/bank-packets/UploadedPackets.vue')
const BankPacketsUploadedPacketOperations = () => import(/* webpackChunkName: "kaluga.BankPackets" */ '../app/bank-packets/UploadedPacketOperations.vue')
const BankPacketsUploadedPacketCreate = () => import(/* webpackChunkName: "kaluga.BankPackets" */ '../app/bank-packets/UploadedPacketCreate.vue')
const BankPacketsSources = () => import(/* webpackChunkName: "kaluga.BankPackets" */ '../app/bank-packets/Sources.vue')
const BankPacketsUnsortedPackets = () => import(/* webpackChunkName: "kaluga.BankPackets" */ '../app/bank-packets/UnsortedPackets.vue')
const BankPacketsUnsortedPacketErrors = () => import(/* webpackChunkName: "kaluga.BankPackets" */ '../app/bank-packets/UnsortedPacketErrors.vue')
const BankPacketsUnsortedPacketErrorUpdate = () => import(/* webpackChunkName: "kaluga.BankPackets" */ '../app/bank-packets/UnsortedPacketErrorUpdate.vue')

// источники образов отходов - отходообразователи в биллинге
const WasteGeneratorsIndividualAreas = () => import(/* webpackChunkName: "kaluga.WasteGenerators" */ '../app/waste-generators/IndividualAreas.vue')
const WasteGeneratorsIndividualAreaUpdate = () => import(/* webpackChunkName: "kaluga.WasteGenerators" */ '../app/waste-generators/IndividualAreaUpdate.vue')
const WasteGeneratorsLegalEntities = () => import(/* webpackChunkName: "kaluga.WasteGenerators" */ '../app/waste-generators/LegalEntities.vue')
const WasteGeneratorsLegalEntitiesExperimental = () => import(/* webpackChunkName: "kaluga.WasteGenerators" */ '../app/waste-generators/LegalEntitiesExperimental.vue')
const WasteGeneratorsLegalEntityUpdate = () => import(/* webpackChunkName: "kaluga.WasteGenerators" */ '../app/waste-generators/LegalEntityUpdate.vue')
const WasteGeneratorsApartmentBuildings = () => import(/* webpackChunkName: "kaluga.WasteGenerators" */ '../app/waste-generators/ApartmentBuildings.vue')
const WasteGeneratorsApartmentBuildingUpdate = () => import(/* webpackChunkName: "kaluga.WasteGenerators" */ '../app/waste-generators/ApartmentBuildingUpdate.vue')

const WasteGeneratorsBankBooksLegalUpdate = () => import(/* webpackChunkName: "kaluga.WasteGenerators" */ '../app/waste-generators/BankBooksLegalUpdate.vue')
const WasteGeneratorsBankBooksApartmentUpdate = () => import(/* webpackChunkName: "kaluga.WasteGenerators" */ '../app/waste-generators/BankBooksApartmentUpdate.vue')
const WasteGeneratorsBankBooksIndividualAreaUpdate = () => import(/* webpackChunkName: "kaluga.WasteGenerators" */ '../app/waste-generators/BankBooksIndividualAreaUpdate.vue')

const WasteGeneratorsBankBooks = () => import(/* webpackChunkName: "kaluga.WasteGenerators" */ '../app/waste-generators/BankBooks.vue')

// импорт файлов
const ImportImportExcel = () => import(/* webpackChunkName: "sverd.import" */ '../app/import/ImportExcel.vue')

// администрирование
const AccessUsers = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/Users.vue')
const AccessUsersGroups = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/UsersGroups.vue')
const AccessUserUpdate = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/region.kalug/UserUpdate.vue')
const AccessUserGroupsUpdate = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/UserGroupsUpdate.vue')
const AccessJournals = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/Journals.vue')

// физ лица
const IndividualsIndividuals = () => import(/* webpackChunkName: "individuals" */ '../app/individuals/Individuals.vue')
const IndividualsUpdate = () => import(/* webpackChunkName: "individuals" */ '../app/individuals/IndividualUpdate.vue')

// груповые операции
const GroupOperationsRecalcIndividuals = () => import(/* webpackChunkName: "croupOperations" */ '../app/group-operations/RecalcIndividuals.vue')
const GroupOperationsRecalcIndividualsUpdate = () => import(/* webpackChunkName: "croupOperations" */ '../app/group-operations/RecalcIndividualsUpdate.vue')

// аналитика
const AnalyticReports = () => import(/* webpackChunkName: "billing.analytic" */ '../app/analytic/ReportsBilling.vue')
const AnalyticReportDownload = () => import(/* webpackChunkName: "billing.analytic" */ '../app/analytic/ReportDownloadBilling.vue')
const AnalyticReportsBillingFiles = () => import(/* webpackChunkName: "billing.analytic" */ '../app/analytic/ReportsBillingFiles.vue')

// разработка
const DevelopmentSettingUpdate = () => import(/* webpackChunkName: "sverd.development" */ '../app/development/SettingUpdate.vue')

const showSubFormInBreadcrumb = (matched) => matched.length > 3

let routes = [
  { path: '/main', name: 'main', component: MainLayout, meta: {requiresAuth: false},
    children: [
      {path: 'error', name: 'main.error', component: MainError, meta: {requiresAuth: false, title: 'Ошибка', noRouteCheck: true}}
    ]
  },
  { path: '/auth', name: 'auth', component: AuthLayout, meta: {requiresAuth: false},
    children: [
      {path: 'login', name: 'auth.login', component: AuthLogin, alias: '/login', meta: {requiresAuth: false, title: 'Вход'}},
      {path: 'set-password', name: 'auth.registerSetPassword', component: AuthRegisterSetPassword, alias: '/set-password', meta: {requiresAuth: false, havePerms: [PERMS.CREATE, PERMS.EDIT], title: 'Установка пароля'}},
      {path: 'request-reset-password', name: 'auth.requestResetPassword', component: AuthRequestResetPassword, alias: '/request-reset-password', meta: {requiresAuth: false, havePerms: [PERMS.CREATE, PERMS.EDIT], title: 'Восстановление пароля'}}
    ]
  },
  {path: '/normative', component: MainLayout, name: 'normative', meta: {title: 'Нормативы', number: '01'},
    redirect: { name: 'normative.legalEntities' },
    children: [
      {
        path: 'legals', component: NormativeLegalEntities, name: 'normative.legalEntities', meta: {title: 'Нормативы для юридических лиц'},
        children: [
          {path: 'create', name: 'normative.legalEntities.create', component: NormativeLegalEntityUpdate},
          {path: 'view/:id', name: 'normative.legalEntities.view', component: NormativeLegalEntityUpdate},
          {path: 'update/:id', name: 'normative.legalEntities.update', component: NormativeLegalEntityUpdate}
        ]
      },
      {
        path: 'apartments', component: NormativeApartmentBuildings, name: 'normative.apartmentBuildings', meta: {title: 'Нормативы для многоквартирных домов'},
        children: [
          {path: 'create', name: 'normative.apartmentBuildings.create', component: NormativeApartmentBuildingUpdate},
          {path: 'view/:id', name: 'normative.apartmentBuildings.view', component: NormativeApartmentBuildingUpdate},
          {path: 'update/:id', name: 'normative.apartmentBuildings.update', component: NormativeApartmentBuildingUpdate}
        ]
      },
      {
        path: 'houses', component: NormativeIndividualAreas, name: 'normative.individualAreas', meta: {title: 'Нормативы для индивидуальных домов'},
        children: [
          {path: 'create', name: 'normative.individualAreas.create', component: NormativeIndividualAreaUpdate},
          {path: 'view/:id', name: 'normative.individualAreas.view', component: NormativeIndividualAreaUpdate},
          {path: 'update/:id', name: 'normative.individualAreas.update', component: NormativeIndividualAreaUpdate}
        ]
      }
    ]
  },
  {path: '/billing/branchs', component: MainLayout, name: 'billing.tariff', meta: {title: 'Тарифы', number: '02'},
    redirect: { name: 'billing.branchs' },
    children: [
      {
        path: '', component: BillingBranchs, name: 'billing.branchs', meta: {title: 'Тарифы'},
        children: [
          {path: 'create', name: 'billing.branchs.create', component: BillingBranchUpdate},
          {path: 'update/:id', name: 'billing.branchs.update', component: BillingBranchUpdate}
        ]
      }
    ]
  },
  {path: '/billing/banks', component: MainLayout, name: 'billing.bank', meta: {title: 'Банки', number: '08'},
    redirect: { name: 'billing.banks' },
    children: [
      {
        path: '', component: BillingBanks, name: 'billing.banks', meta: {title: 'Банки'},
        children: [
          {path: 'create', name: 'billing.banks.create', component: BillingUpdate},
          {path: 'update/:id', name: 'billing.banks.update', component: BillingUpdate}
        ]
      }
    ]
  },
  {path: '/group-operations', component: MainLayout, name: 'groupOperations', meta: {title: 'Групповые операции', number: '07'},
    redirect: { name: 'groupOperations.recalcIndividuals' },
    children: [
      {
        path: 'recalc-individuals', component: GroupOperationsRecalcIndividuals, name: 'groupOperations.recalcIndividuals', meta: {title: 'Перерасчет по физическим лицам'},
        children: [
          {
            path: 'update', name: 'groupOperations.recalcIndividuals.update', component: GroupOperationsRecalcIndividualsUpdate, meta: {title: 'Перерасчет'},
          }
        ]
      }
    ]
  },
  { path: '/waste-generators', component: MainLayout, name: 'wasteGenerators', meta: {title: 'Потребители услуг', number: '03'},
    redirect: { name: 'wasteGenerators.legalEntities' },
    children: [
      {
        path: 'legals/experimental', component: WasteGeneratorsLegalEntitiesExperimental, name: 'wasteGenerators.legalEntitiesExperimental', meta: {title: 'Юридические лица Experimental'},
        children: [
          {path: 'create', name: 'wasteGenerators.legalEntitiesExperimental.create', component: WasteGeneratorsLegalEntityUpdate,
            meta: {showInBreadcrumb: showSubFormInBreadcrumb, title: 'Добавление новой записи'},
            children: [
              {path: 'bill-create', name: 'wasteGenerators.legalEntitiesExperimental.create.billCreate', component: WasteGeneratorsBankBooksLegalUpdate},
              {path: 'bill-update/:objectId', name: 'wasteGenerators.legalEntitiesExperimental.create.billUpdate', component: WasteGeneratorsBankBooksLegalUpdate}
            ]
          },
          {path: 'update/:id', name: 'wasteGenerators.legalEntitiesExperimental.update', component: WasteGeneratorsLegalEntityUpdate,
            meta: {showInBreadcrumb: showSubFormInBreadcrumb, title: 'Редактирование записи'},
            children: [
              {path: 'bill-create', name: 'wasteGenerators.legalEntitiesExperimental.update.billCreate', component: WasteGeneratorsBankBooksLegalUpdate},
              {path: 'bill-update/:objectId', name: 'wasteGenerators.legalEntitiesExperimental.update.billUpdate', component: WasteGeneratorsBankBooksLegalUpdate}
            ]
          }
        ]
      },
      {
        path: 'legals', component: WasteGeneratorsLegalEntities, name: 'wasteGenerators.legalEntities', meta: {title: 'Юридические лица'},
        children: [
          {path: 'create', name: 'wasteGenerators.legalEntities.create', component: WasteGeneratorsLegalEntityUpdate,
            meta: {showInBreadcrumb: showSubFormInBreadcrumb, title: 'Добавление новой записи'},
            children: [
              {path: 'bill-create', name: 'wasteGenerators.legalEntities.create.billCreate', component: WasteGeneratorsBankBooksLegalUpdate},
              {path: 'bill-update/:objectId', name: 'wasteGenerators.legalEntities.create.billUpdate', component: WasteGeneratorsBankBooksLegalUpdate}
            ]
          },
          {path: 'update/:id', name: 'wasteGenerators.legalEntities.update', component: WasteGeneratorsLegalEntityUpdate,
            meta: {showInBreadcrumb: showSubFormInBreadcrumb, title: 'Редактирование записи'},
            children: [
              {path: 'bill-create', name: 'wasteGenerators.legalEntities.update.billCreate', component: WasteGeneratorsBankBooksLegalUpdate},
              {path: 'bill-update/:objectId', name: 'wasteGenerators.legalEntities.update.billUpdate', component: WasteGeneratorsBankBooksLegalUpdate}
            ]
          }
        ]
      },
      {
        path: 'apartments', component: WasteGeneratorsApartmentBuildings, name: 'wasteGenerators.apartmentBuildings', meta: {title: 'Многоквартирные дома'},
        children: [
          {path: 'create', name: 'wasteGenerators.apartmentBuildings.create', component: WasteGeneratorsApartmentBuildingUpdate,
            meta: {showInBreadcrumb: showSubFormInBreadcrumb, title: 'Добавление записи'},
            children: [
              {path: 'bill-create', name: 'wasteGenerators.apartmentBuildings.create.billCreate', component: WasteGeneratorsBankBooksApartmentUpdate,
                meta: {title: 'Добавление лицевого счета'},
                children: [
                  {
                    path: 'individual/create', name: 'wasteGenerators.apartmentBuildings.create.billCreate.individual.create', component: IndividualsUpdate,
                    meta: {
                      showInBreadcrumb: showSubFormInBreadcrumb
                    }
                  }
                ]
              },
              {path: 'bill-update/:objectId', name: 'wasteGenerators.apartmentBuildings.create.billUpdate', component: WasteGeneratorsBankBooksApartmentUpdate,
                meta: {title: 'Добавление лицевого счета'},
                children: [
                  {
                    path: 'individual/create', name: 'wasteGenerators.apartmentBuildings.create.billUpdate.individual.create', component: IndividualsUpdate,
                    meta: {
                      showInBreadcrumb: showSubFormInBreadcrumb
                    }
                  }
                ]
              }
            ]
          },
          {path: 'update/:id', name: 'wasteGenerators.apartmentBuildings.update', component: WasteGeneratorsApartmentBuildingUpdate,
            meta: {showInBreadcrumb: showSubFormInBreadcrumb, title: 'Редактирование записи'},
            children: [
              {path: 'bill-create', name: 'wasteGenerators.apartmentBuildings.update.billCreate', component: WasteGeneratorsBankBooksApartmentUpdate,
                meta: {title: 'Добавление лицевого счета'},
                children: [
                  {
                    path: 'individual/create', name: 'wasteGenerators.apartmentBuildings.update.billCreate.individual.create', component: IndividualsUpdate,
                    meta: {
                      showInBreadcrumb: showSubFormInBreadcrumb
                    }
                  }
                ]
              },
              {path: 'bill-update/:objectId', name: 'wasteGenerators.apartmentBuildings.update.billUpdate', component: WasteGeneratorsBankBooksApartmentUpdate,
                meta: {title: 'Редактирование лицевого счета'},
                children: [
                  {
                    path: 'individual/create', name: 'wasteGenerators.apartmentBuildings.update.billUpdate.individual.create', component: IndividualsUpdate,
                    meta: {
                      showInBreadcrumb: showSubFormInBreadcrumb
                    }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: 'houses', component: WasteGeneratorsIndividualAreas, name: 'wasteGenerators.individualAreas', meta: {title: 'Индивидуальные дома'},
        children: [
          {path: 'create', name: 'wasteGenerators.individualAreas.create', component: WasteGeneratorsIndividualAreaUpdate,
            meta: {showInBreadcrumb: showSubFormInBreadcrumb, title: 'Добавление записи'},
            children: [
              {path: 'bill-create', name: 'wasteGenerators.individualAreas.create.billCreate', component: WasteGeneratorsBankBooksApartmentUpdate,
                meta: {title: 'Добавление лицевого счета'},
                children: [
                  {
                    path: 'individual/create', name: 'wasteGenerators.individualAreas.create.billCreate.individual.create', component: IndividualsUpdate,
                    meta: {
                      showInBreadcrumb: showSubFormInBreadcrumb
                    }
                  }
                ]
              },
              {path: 'bill-update/:objectId', name: 'wasteGenerators.individualAreas.create.billUpdate', component: WasteGeneratorsBankBooksApartmentUpdate,
                meta: {title: 'Добавление лицевого счета'},
                children: [
                  {
                    path: 'individual/create', name: 'wasteGenerators.individualAreas.create.billUpdate.individual.create', component: IndividualsUpdate,
                    meta: {
                      showInBreadcrumb: showSubFormInBreadcrumb
                    }
                  }
                ]
              }
            ]
          },
          {path: 'update/:id', name: 'wasteGenerators.individualAreas.update', component: WasteGeneratorsIndividualAreaUpdate,
            meta: {showInBreadcrumb: showSubFormInBreadcrumb, title: 'Редактирование записи'},
            children: [
              {path: 'bill-create', name: 'wasteGenerators.individualAreas.update.billCreate', component: WasteGeneratorsBankBooksIndividualAreaUpdate,
                meta: {title: 'Добавление лицевого счета'},
                children: [
                  {
                    path: 'individual/create', name: 'wasteGenerators.individualAreas.update.billCreate.individual.create', component: IndividualsUpdate,
                    meta: {
                      showInBreadcrumb: showSubFormInBreadcrumb
                    }
                  }
                ]
              },
              {path: 'bill-update/:objectId', name: 'wasteGenerators.individualAreas.update.billUpdate', component: WasteGeneratorsBankBooksIndividualAreaUpdate,
                meta: {title: 'Редактирование лицевого счета'},
                children: [
                  {
                    path: 'individual/create', name: 'wasteGenerators.individualAreas.update.billUpdate.individual.create', component: IndividualsUpdate,
                    meta: {
                      showInBreadcrumb: showSubFormInBreadcrumb
                    }
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/waste-generators-bills', component: MainLayout, name: 'wasteGeneratorsBills', meta: {title: 'Реестр лицевых счетов', number: '12'},
    redirect: {name: 'wasteGeneratorsBills.bills'},
    children: [
      {
        path: 'bills', component: WasteGeneratorsBankBooks, name: 'wasteGeneratorsBills.bills', meta: {title: 'Реестр лицевых счетов'}
      }
    ]
  },
  {path: '/payment/payments', component: MainLayout, name: 'payment.payments', meta: {title: 'Ввод платежей', number: '05'},
    redirect: { name: 'payment.payments.payments' },
    children: [
      {
        path: '', component: PaymentPayments, name: 'payment.payments.payments', meta: {title: 'Оплата по квитанциям'},
        children: [
          {path: 'create', name: 'payment.payments.payments.create', component: PaymentPaymentUpdate},
          {path: 'update/:id', name: 'payment.payments.payments.update', component: PaymentPaymentUpdate}
        ]
      },
      {
        path: 'bills', component: PaymentPaymentBills, name: 'payment.payments.paymentBills', meta: {title: 'Оплата по счетам'},
        children: [
          {path: 'create', name: 'payment.payments.paymentBills.create', component: PaymentPaymentBillUpdate},
          {path: 'update/:id', name: 'payment.payments.paymentBills.update', component: PaymentPaymentBillUpdate}
        ]
      }
    ]
  },
  {path: '/payment', component: MainLayout, name: 'payment', meta: {title: 'Начисление', number: '06'},
    redirect: { name: 'payment.invoices' },
    children: [
      {
        path: 'invoices', component: PaymentInvoices, name: 'payment.invoices', meta: {title: 'Квитанции'},
        children: [
          {path: 'create', name: 'payment.invoices.create', component: PaymentInvoiceCreate}
        ]
      },
      {path: 'invoices/:packetId/errors', name: 'payment.invoices.invoicePacketErrors', component: PaymentInvoicePacketErrors, meta: {title: 'Ошибки в пачке'}},
      {path: 'invoices/:packetId/items', name: 'payment.invoices.invoicePacketItems', component: PaymentInvoicePacketItems, meta: {title: 'Пачка'}},
      {
        path: 'legal-accruals', component: PaymentAccrualsLegals, name: 'payment.accrualsLegals', meta: {title: 'Счета на оплату'},
        children: [
          {path: 'create', name: 'payment.accrualsLegals.create', component: PaymentAccrualsLegalCreate}
        ]
      },
      {path: 'legal-accruals/:packetId/packet', name: 'payment.accrualsLegalPacket', component: PaymentAccrualsLegalPacket, meta: {title: 'Пачка'}},
    ]
  },
  {path: '/bank-packets', component: MainLayout, name: 'bankPackets', meta: {title: 'Банковские пачки', number: '09'},
    redirect: { name: 'bankPackets.uploadedPackets' },
    children: [
      {
        path: 'uploaded-packets', component: BankPacketsUploadedPackets, name: 'bankPackets.uploadedPackets', meta: {title: 'Загрузка реестров ЛС'},
        children: [
          {path: 'create', name: 'bankPackets.uploadedPackets.create', component: BankPacketsUploadedPacketCreate}
        ]
      },
      {
        path: 'uploaded-packets/:id/operations', component: BankPacketsUploadedPacketOperations, name: 'bankPackets.uploadedPackets.operations', meta: {title: 'Просмотр пачки'}
      },
      {
        path: 'unsorted-packets', component: BankPacketsUnsortedPackets, name: 'bankPackets.unsortedPackets', meta: {title: 'Нераспределенные ЛС'},
      },
      {
        path: 'unsorted-packets/:packetId/errors', component: BankPacketsUnsortedPacketErrors, name: 'bankPackets.unsortedPackets.errors', meta: {title: 'Ошибки пачки'},
        children: [
          {path: 'update/:id', name: 'bankPackets.unsortedPackets.errors.update', component: BankPacketsUnsortedPacketErrorUpdate}
        ]
      },
      {
        path: 'sources', component: BankPacketsSources, name: 'bankPackets.sources', meta: {title: 'Источники'}
      }
    ]
  },
  {path: '/individuals', component: MainLayout, name: 'individuals', meta: {title: 'Реестр физических лиц', number: '13'},
    redirect: { name: 'individuals.individuals' },
    children: [
      {
        path: '', component: IndividualsIndividuals, name: 'individuals.individuals', meta: {title: 'Реестр физических лиц'},
        children: [
          {path: 'create', name: 'individuals.individuals.create', component: IndividualsUpdate},
          {path: 'update/:id', name: 'individuals.individuals.update', component: IndividualsUpdate}
        ]
      }
    ]
  },
  { path: '/admin/', component: MainLayout, name: 'access', meta: {title: 'Администрирование', number: '11'},
    redirect: { name: 'access.users' },
    children: [
      { path: '', component: AccessUsers, name: 'access.users', meta: {title: 'Пользователи'},
        children: [
          {path: 'create', name: 'access.users.create', component: AccessUserUpdate},
          {path: 'update/:id', name: 'access.users.update', component: AccessUserUpdate}
        ]
      },
      { path: 'users-groups', component: AccessUsersGroups, name: 'access.usersGroups', meta: {title: 'Группы пользователей'},
        children: [
          {path: 'create', name: 'access.usersGroups.create', component: AccessUserGroupsUpdate},
          {path: 'update/:id', name: 'access.usersGroups.update', component: AccessUserGroupsUpdate}
        ]
      },
      { path: 'journals', component: AccessJournals, name: 'access.journals', meta: {title: 'Журнал изменений'}},
    ]
  },
  { path: '/analytics/', component: MainLayout, name: 'analytic', meta: {title: 'Аналитика', number: '14'},
    redirect: { name: 'analytic.reports' },
    children: [
      {
        path: 'reports', component: AnalyticReports, name: 'analytic.reports', meta: {title: 'Отчеты'},
        children: [
          {path: 'report/:reportId/:windowType', name: 'analytic.reports.report', component: AnalyticReportDownload, meta: {title: 'Отчеты'}}
        ]
      },
      {
        path: 'reports-billing-files', component: AnalyticReportsBillingFiles, name: 'analytic.reportsBillingFiles', meta: {title: 'Хранилище файлов'},
      }
    ]
  },
  {path: '/invoice-control', component: MainLayout, name: 'invoiceControl', meta: {title: 'Контроль счетов', number: '15'},
    redirect: { name: 'invoiceControl.bankStatements' },
    children: [
      {
        path: 'bank-statement', component: InvoiceControlBankStatements, name: 'invoiceControl.bankStatements', meta: {title: 'Банковские выписки'},
        children: [
          {path: 'create', name: 'invoiceControl.bankStatements.create', component: InvoiceControlBankStatementCreate}
        ]
      },
      {
        path: 'bank-statement/items/:statementId', component: InvoiceControlBankStatementItems, name: 'invoiceControl.bankStatementItems', meta: {title: 'Информация по банковской выписке'},
        children: [
          {path: 'create', name: 'invoiceControl.bankStatementItems.bankStatementItemsLink.create', component: InvoiceControlBankStatementItemsLinkCreate}
        ]
      },
      {
        path: 'bills-of-waste-generators', component: InvoiceControlBillsOfWasteGenerators, name: 'invoiceControl.billsOfWasteGenerators', meta: {title: 'Счета поставщика услуг'},
        children: [
          {path: 'create', name: 'invoiceControl.billsOfWasteGenerators.create', component: InvoiceControlBillOfWasteGeneratorUpdate},
          {path: 'update/:id', name: 'invoiceControl.billsOfWasteGenerators.update', component: InvoiceControlBillOfWasteGeneratorUpdate}
        ]
      }
    ]
  },
  {path: '/import', component: MainLayout, name: 'import', meta: {title: 'Импорт данных', number: ' ', hideInMenu: true},
    children: [
      { path: 'excel', component: ImportImportExcel, name: 'import.importExcel', meta: {title: 'Импорт даннных', hideInMenu: true}}
    ]
  },
  { path: '/profile', component: AccountUserProfileLayout, name: 'account', meta: {title: 'Личный кабинет', number: '13', hideInMenu: true},
    redirect: { name: 'account.userProfile' },
    children: [
      { path: '', component: AccountUserProfile, name: 'account.userProfile', meta: {title: 'Личный кабинет', hideInMenu: true}}
    ]
  },
  { path: '/development', component: MainLayout, name: 'development', meta: {title: 'Разработка', number: '0', hideInMenu: true},
    redirect: { name: 'development.settingUpdate' },
    children: [
      { path: 'setting-update', component: DevelopmentSettingUpdate, name: 'development.settingUpdate', meta: {title: 'Меню разработки', hideInMenu: true}}
    ]
  },
  {path: '*', redirect: DEFAULT_REDIRECT.default}
]

export default {
  /* mode: 'history', */
  linkActiveClass: 'active',
  routes: routes
}
